<script>
  import SettingsCard from '../shared/SettingsCard.svelte';
  import SettingField from '../shared/SettingField.svelte';

  export let form;

  const inputClass =
    'h-11 w-full rounded-lg border border-slate-300 bg-white px-3 text-sm text-slate-900 shadow-sm outline-none transition placeholder:text-slate-400 focus:border-blue-500 focus:ring-2 focus:ring-blue-100';
</script>

<SettingsCard title="Work Information" description="Employee and contact details for internal workflows.">
  <div class="grid grid-cols-1 gap-4 md:grid-cols-2">
    <SettingField id="work-employee-code" label="Employee Code">
      <input id="work-employee-code" bind:value={form.employeeCode} class={inputClass} />
    </SettingField>

    <SettingField id="work-phone" label="Phone Number">
      <input id="work-phone" bind:value={form.phone} class={inputClass} />
    </SettingField>

    <SettingField id="work-department" label="Department">
      <input id="work-department" bind:value={form.department} class={inputClass} />
    </SettingField>

    <SettingField id="work-position" label="Position">
      <input id="work-position" bind:value={form.position} class={inputClass} />
    </SettingField>
  </div>
</SettingsCard>
